module.exports = __webpack_public_path__ + "img/qarabag-fk.df3a0101.png";